export default __webpack_public_path__ + "static/media/colorWhatIfHigh.3cd52638.svg";